class UrlBaseConst {
    static BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
    static API_URL =  `${UrlBaseConst.BASE_URL}/v1`;
}

export const UrlConst = {
    BASE_URL: UrlBaseConst.BASE_URL,
    FETCH_PAYMENT_DATA: `${UrlBaseConst.API_URL}/payment/:id`,
    GENERATE_PAYMENT_LINK: `${UrlBaseConst.API_URL}/payment/:id/generate`,
    CONFIRM_CLAIM_CODE_LINK: `${UrlBaseConst.API_URL}/payment/:id/confirm-claim-code`,
    FETCH_BANKS_LINK: `${UrlBaseConst.API_URL}/bank/fetch-all`,
    RESOLVE_BANK_LINK: `${UrlBaseConst.API_URL}/bank/resolve-account`,
    CLAIM_PAYOUT_LINK: `${UrlBaseConst.API_URL}/payment/:id/claim-payout`,
    FETCH_VAS_SERVICES_LINK: `${UrlBaseConst.API_URL}/vas/fetch-all`,
    FETCH_VAS_CATEGORIES_LINK: `${UrlBaseConst.API_URL}/vas/:id/categories`,
    FETCH_VAS_PRODUCTS_LINK: `${UrlBaseConst.API_URL}/vas/service-category/:id/products`,
    VERIFY_VAS_ENTITY_LINK: `${UrlBaseConst.API_URL}/vas/verify-entity`,
    CHECK_PAYMENT_STATUS_LINK: `${UrlBaseConst.API_URL}/payment/status/:reference`,
};
